import axios, { AxiosRequestConfig, type AxiosResponse } from 'axios';

interface CreateAuthHttpClientProps {
  bearerAccessToken?: string;
  clientId?: string;
}

export const createAuthHttpClient =
  ({ bearerAccessToken, clientId }: CreateAuthHttpClientProps) =>
  async <T>(request: AxiosRequestConfig): Promise<AxiosResponse<T>> => {
    const requestInstance = axios.create(request);
    if (bearerAccessToken)
      requestInstance.defaults.headers.common['Authorization'] = `Bearer ${bearerAccessToken}`;
    else requestInstance.defaults.headers.common['apiKey'] = clientId;
    const response: AxiosResponse<T> = await requestInstance.request<T>(request);
    return response;
  };
